import React, { useState } from "react";
import contact from "../assets/Initiatives/1000pix_Imam-Ridha-p-and-the-Importance-of-Charity_WSG.jpg";
import "../css/contactForm.css";
import emailjs from "emailjs-com";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useSelector } from "react-redux";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const currentTheme = useSelector((state) => state.theme.current);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!formData.name.trim()) {
      errors.name = "Please enter your name";
      isValid = false;
    }

    if (!formData.email.trim()) {
      errors.email = "Please enter your email";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Please enter a valid email address";
      isValid = false;
    }

    if (!formData.phone.trim()) {
      errors.phone = "Please enter your phone number";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.phone)) {
      errors.phone = "Please enter a valid phone number";
      isValid = false;
    }

    if (!formData.subject.trim()) {
      errors.subject = "Please enter a subject";
      isValid = false;
    }

    if (!formData.message.trim()) {
      errors.message = "Please enter your message";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  const addMails = async (mail) => {
    try {
      await addDoc(collection(db, "Mails"), {
        date: Timestamp.now(),
        details: mail,
        status: "pending",
        bookedBy: "",
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      addMails(formData);

      let form_data = `
        Al Qaim Contact Form
        from_name: ${formData.name},
        from_email: ${formData.email}, 
        from_number: ${formData.phone}, 
        subject: ${formData.subject}, 
        message: ${formData.message}, 
      `;

      await fetch(
        "https://discord.com/api/webhooks/1473732030280896697/XAbn9Pnm3HKsjDOKLGMxitfyqvRp5oBSMIkS7jyLfxMVfx0ptshvrYfDxZri6E_M1WxO",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            embeds: [
              {
                title: "New Help Form Submission",
                color: 5814783,
                description: form_data.slice(0, 6000),
                timestamp: new Date(),
              },
            ],
          }),
        },
      );

      emailjs
        .send(
          "service_y5g4vjs",
          "template_1ayop5o",
          {
            to_name: "Recipient", // Use a placeholder or dynamically set if needed
            from_name: formData.name, // Matches {{from_name}} in template
            from_email: formData.email, // Matches {{from_email}} in template
            from_number: formData.phone, // Matches {{from_phone}} in template
            subject: formData.subject, // Matches {{subject}} in template
            message: formData.message, // Matches {{message}} in template
          },
          "ivuz1YIJqTWXipbyc",
        )
        .then((response) => {
          console.log(
            "Email sent successfully!",
            response.status,
            response.text,
          );
          document.getElementById("success").innerHTML =
            "✔ Message Sent Successfully!";
          setFormData({
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
          });
        })
        .catch((error) => {
          console.error("Error sending email:", error);
          document.getElementById("success").innerHTML =
            "✖ Error Sending Message.";
        });
    } else {
      document.getElementById("success").innerHTML = "";
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  return (
    <>
      <div className="contact" style={{ background: `${currentTheme}` }}>
        <div className="container">
          <div className="section-header text-center">
            <h3>Get In Touch</h3>
            <h2>Contact for any query</h2>
          </div>
          <div className="contact-img">
            <img src={contact} alt="Image" />
          </div>
          <div className="contact-form">
            <div className="sent text-success" id="success"></div>
            <form
              name="sentMessage"
              id="contactForm"
              onSubmit={handleSubmit}
              noValidate
            >
              <div className="control-group">
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  autoComplete="name"
                  required
                />
                <p className="text-danger">{errors.name}</p>
              </div>
              <div className="control-group">
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="email"
                  required
                />
                <p className="text-danger">{errors.email}</p>
              </div>
              <div className="control-group">
                <input
                  type="number"
                  className="form-control"
                  id="phone"
                  placeholder="Your Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  autoComplete="phone"
                  required
                />
                <p className="text-danger">{errors.phone}</p>
              </div>
              <div className="control-group">
                <input
                  type="text"
                  className="form-control"
                  id="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
                <p className="text-danger">{errors.subject}</p>
              </div>
              <div className="control-group">
                <textarea
                  className="form-control"
                  id="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
                <p className="text-danger">{errors.message}</p>
              </div>
              <div>
                <button
                  type="submit"
                  id="sendMessageButton"
                  style={{ color: `${currentTheme}` }}
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactForm;
